import { createAsyncThunk } from '@reduxjs/toolkit'
import Category from './category-model'
import {
  delete_category,
  load_categorys,
  store_category,
} from './category-service'

export const LoadCategorysAsync = createAsyncThunk<any, any>(
  'composer/load/category',
  async (params: { uid: string }) => {
    return await load_categorys(params)
  },
)

export const CreateCategoryAsync = createAsyncThunk<any, any>(
  'composer/create/category',
  async (params: Category) => {
    return await store_category(params)
  },
)

export const DeleteCategoryAsync = createAsyncThunk<any, any>(
  'composer/delete/category',
  async (params) => {
    return await delete_category(params)
  },
)
